// extracted by mini-css-extract-plugin
export var cartIcon = "_mx-0";
export var cartIconContainer = "_mx-1";